import { render, staticRenderFns } from "./numberProfit.vue?vue&type=template&id=554f6643&scoped=true&"
import script from "./numberProfit.vue?vue&type=script&lang=js&"
export * from "./numberProfit.vue?vue&type=script&lang=js&"
import style0 from "./numberProfit.vue?vue&type=style&index=0&id=554f6643&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554f6643",
  null
  
)

export default component.exports